import classNames from 'classnames';
import { actions } from '../../context';
import { useDispatch, useSelector } from 'react-redux';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBookmark } from '@fortawesome/free-regular-svg-icons';
import { useCallback } from 'react';

const Bookmark = ({ practiceId, isBookmarked }) => {
    const dispatch = useDispatch();

    const currentPracticeId = useSelector(
        (state) => state.practice.currentPracticeId
    );

    const refresh = useCallback(() => {
        dispatch(actions.toggle.triggerRefresh());
        if (practiceId === currentPracticeId) {
            dispatch(actions.toggle.triggerPracticeRefresh());
        }
    }, [dispatch, practiceId, currentPracticeId]);

    const onClick = useCallback(() => {
        if (isBookmarked === true) {
            dispatch(actions.practice.removePracticeBookmark(practiceId)).then(
                refresh
            );
        } else {
            dispatch(actions.practice.addPracticeBookmark(practiceId)).then(
                refresh
            );
        }
    }, [isBookmarked, practiceId, dispatch, refresh]);

    return (
        <FontAwesomeIcon
            onClick={onClick}
            icon={isBookmarked ? 'bookmark' : faBookmark}
            className={classNames('pop-hover', {
                'hover-child': !isBookmarked,
            })}
            title={
                isBookmarked === true
                    ? 'Remove bookmark'
                    : 'Bookmark this practice'
            }
        />
    );
};

export default Bookmark;
